<template>
  <div class="spese-wrapper">
    <b-table-simple
      small
      class="spese-table"
    >
      <b-thead>
        <b-tr>
          <b-th class="id-col">ID</b-th>
          <b-th class="tipo-col">TIPO</b-th>
          <b-th class="categoria-col">CATEGORIA</b-th>
          <b-th class="text-right importo-col">IMPORTO</b-th>
          <b-th class="text-right anno-col">ANNO</b-th>
         </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="spesa in transazioni"
          :key="spesa.id"
        >
          <b-td class="id-col">
            {{ spesa.id }}
          </b-td>
          <b-td class="tipo-col">
            <span
              class="tipo-chip"
              v-b-tooltip.hover
              :title="tooltipTipo(spesa.tipo)"
            >
              {{ spesa.tipo }}
            </span>
          </b-td>
          <b-td class="categoria-col">
            {{ spesa.categoria }}
          </b-td>
          <b-td class="text-right importo-col" >
            {{ formatEuro(spesa.importo) }}
          </b-td>
          <b-td class="text-right anno-col">
            {{ spesa.anno }}
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>

export default {

  name: "PICSpeseDipendenti",
  props: {
    transazioni: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    tooltipTipo(tipo) {
      if (tipo === "F") {
        return "Figurativo";
      }

      if (tipo === "R") {
        return "Rimborsuale";
      }

      return "";
    },

    // Formatta l'importo in euro con separatore delle migliaia e due decimali
    formatEuro(value) {

      const numero = new Intl.NumberFormat(
        "it-IT",
        {
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }
      ).format(value || 0);

      return `€ ${numero}`;
    }
  }
};

</script>

<style scoped>

.spese-wrapper{
    background:#fafbfc;
    border-top:1px solid #e8e8e8;
    padding:10px;
}

.spese-table{
    margin-bottom:0;
}
/* Arrotonda gli angoli superiori dell'header */
.spese-table thead th:first-child {
    border-radius:8px 0 0 0;
}

.spese-table thead th:last-child {
    border-radius:0 8px 0 0;
}


.spese-table thead th{
    background:#373F66;
    color:white;
    font-size:11px;
    font-weight:600;
    border:0;
    vertical-align:middle;
}

.spese-table tbody td{
    font-size:13px;
    vertical-align:middle;
}

.text-right{
    text-align:right;
}

.tipo-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  padding: 0 8px;
  border-radius: 999px;
  background: rgb(232, 245, 252);
  color: rgb(42, 170, 226);
  font-weight: 700;
  font-size: 13px;
}

.id-col{
    width:120px;
}

.tipo-col{
    width:80px;
}

.categoria-col{
    width:auto;
}
/* Evidenzia il nome della categoria nelle righe */
.spese-table tbody .categoria-col {
    font-weight:600;
}

.importo-col{
    width:150px;
}

.anno-col{
    width:110px;
    padding-right:25px !important;
}

</style>